import { inject } from '@angular/core';
import { FALLBACK_LANGUAGE_LOCALE } from '@move/core';
import { TranslateService } from '@ngx-translate/core';


/**
 * This class is used as a provider for the LOCALE_ID token. It returns the current language of the TranslateService.
 * If the current language is not set, it returns the default language of the TranslateService. If the default language
 * is not set, it returns the fallback language.
 *
 * This implementation makes it possible to use the TranslateService to dynamically change the LOCALE_ID of the
 * application, which would otherwise not be possible, and is useful for pipe formatting of the Angular builtin pipes.
 *
 * See: https://stackoverflow.com/a/72548920/24458023
 */
export class DynamicLocaleId extends String {
  private translate = inject(TranslateService);

  toString(): string {
    return this.translate.currentLang?.toString() ?? this.translate.defaultLang?.toString() ?? FALLBACK_LANGUAGE_LOCALE;
  }
}
